<template>
  <div
    class="ll-stepper-step"
    :class="{active:isActive}"
    @click="onClick()"
  >
    <div
      v-if="haveLine"
      class="ll-stepper-step_divider"
      :style="{width:dividerWidth+'px'}"
    />
    <div class="ll-stepper-step_content">
      <p
        v-if="stepNumber"
        class="step-number"
      >
        {{ stepNumber }}
      </p>
      <i
        v-if="stepIcon"
        class="step-icon"
        :class="stepIcon"
      />
      <div
        v-if="title"
        class="ll-stepper-step_content-title"
      >
        {{ $t(title) }}
      </div>
    </div>
    <div
      v-if="isComplete"
      class="ll-stepper-step_content"
    >
      <p
        v-if="stepNumber"
        class="step-number"
      >
        {{ stepNumber }}
      </p>
      <i
        v-if="completeIcon"
        class="step-icon"
        :class="completeIcon"
      />
      <div
        v-if="completeTitle"
        class="ll-stepper-step_content-title"
      >
        {{ completeTitle }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlStepperStep",
  props: {
    title: {
      type: String,
      default: "",
    },
    stepNumber: {
      type: Number,
      default: 0,
    },
    stepIcon: {
      type: String,
      default: "",
    },
    completeIcon: {
      type: String,
      default: "",
    },
    completeTitle: {
      type: String,
      default: "",
    },
    isComplete: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    dividerWidth: {
      type: Number,
      default: 185,
    },
    haveLine: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick($event) {
      if (!this.isComplete) return;
      this.$emit("step-click", $event);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-stepper-step";
</style>